import styled from 'styled-components'
import getBreakpoint from '@client/utils/breakpoints'

import { H2, H4, Paragraph } from '@components/Text'

export const ImageWrapper = styled.img`
  max-width: 100%;
`

export const Main = styled.section`
  padding-top: 64px;
  padding-bottom: 64px;
  background-color: var(--vila-olimpia-10);

  @media (min-width: ${getBreakpoint('xl')}px) {
    padding-top: 72px;
    padding-bottom: 72px;
  }
`

export const Title = styled(H2)`
  font-weight: 300;
  line-height: 42px;
  color: var(--primary-text);

  strong {
    font-weight: 700;
  }

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin-top: 59px;
    max-width: 400px;
  }
`

export const Subtitle = styled(H4)`
  font-weight: 400;
  line-height: 23px;
  margin-top: 16px;
  color: var(--primary-text);

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin-top: 24px;
  }
`

export const ButtonWrapper = styled.section`
  margin-top: 24px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin-top: 16px;
  }
`

export const ButtonTextWrapper = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ButtonText = styled(Paragraph)`
  margin-left: 8px;
  font-weight: 600;
`
